var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.001,
    height: 32.326,
    viewBox: "0 0 44.001 32.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10530.04-6510.674a4.041,4.041,0,0,1-4.04-4.04v-24.246a4.041,4.041,0,0,1,4.04-4.041h35.918a4.042,4.042,0,0,1,4.043,4.041v24.246a4.041,4.041,0,0,1-4.043,4.04Zm-1.345-4.04a1.347,1.347,0,0,0,1.345,1.348h35.918a1.348,1.348,0,0,0,1.348-1.348v-23.7l-16.638,15.121a3.9,3.9,0,0,1-5.364,0l-16.608-14.6Zm18.279-10.887a1.452,1.452,0,0,0,1.984,0l16.178-14.7H10530.3Z",
    transform: "translate(-10526 6543)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.12a26a548bbc153818436247ff71272a.svg";
export { ForwardRef as ReactComponent };